import * as Vest from 'vest';
import 'vest/enforce/compounds';
import { DateTime as LuxonDateTime} from 'luxon';
import dayjs from 'dayjs';


function validateDateFormat(dt:Date): boolean {
    let d2 = dt.toISOString();
    return(LuxonDateTime.fromISO(d2).isValid)
  }

function validateDateRange(dt:Date): boolean{
    let d2 = dt.toISOString();
  
    if (LuxonDateTime.fromISO(d2).isValid)
    {
        let ageLimit = 16;
        let dateYear=new Date(d2).getFullYear();
        let dateYearLimit = new Date().getFullYear() - ageLimit;

        if((dateYear < 1900) || (dateYear > dateYearLimit))
        {
            return false;
        }
        else
        {
            return true;
        }
    }
    else
    {
        return false;
    }
}

export const FormSuite = Vest.create((data = {}) => {
 
 

    Vest.test('BirthDate','ERROR_FORMAT_DDMMYYYY', () => {
        return validateDateFormat(data.BirthDate);
    });

    Vest.test('BirthDate','ERROR_DATE_RANGE', () => {
        return validateDateRange(data.BirthDate);
    });

  
    // greater than 0
    Vest.test('depChildren', 'ERROR_DEPENDENT_RANGE', () => {
        Vest.enforce(data.depChildren).allOf(Vest.enforce.greaterThanOrEquals(0), Vest.enforce.lessThanOrEquals(9));
    });

    Vest.test('depChildrenDis', 'ERROR_DEPENDENT_RANGE', () => {
        Vest.enforce(data.depChildrenDis).allOf(Vest.enforce.greaterThanOrEquals(0), Vest.enforce.lessThanOrEquals(9));
    });

    Vest.test('depOthers', 'ERROR_DEPENDENT_RANGE', () => {
        Vest.enforce(data.depOthers).allOf(Vest.enforce.greaterThanOrEquals(0), Vest.enforce.lessThanOrEquals(9));
    });

    Vest.test('depOthersDis', 'ERROR_DEPENDENT_RANGE', () => {
        Vest.enforce(data.depOthersDis).allOf(Vest.enforce.greaterThanOrEquals(0), Vest.enforce.lessThanOrEquals(9));
    });

    Vest.test('dep65Transition', 'ERROR_DEPENDENT_RANGE', () => {
        Vest.enforce(data.dep65Transition).allOf(Vest.enforce.greaterThanOrEquals(0), Vest.enforce.lessThanOrEquals(9));
    });

    Vest.test('dep65TransitionDis', 'ERROR_DEPENDENT_RANGE', () => {
        Vest.enforce(data.dep65TransitionDis).allOf(Vest.enforce.greaterThanOrEquals(0), Vest.enforce.lessThanOrEquals(9));
    });

    Vest.test('dep65Dependent', 'ERROR_DEPENDENT_RANGE', () => {
        Vest.enforce(data.dep65Dependent).allOf(Vest.enforce.greaterThanOrEquals(0), Vest.enforce.lessThanOrEquals(9));
    });

    /*
    Vest.test('dep65DependentDis', 'ERROR_DEPENDENT_RANGE', () => {
        Vest.enforce(data.dep65DependentDis).allOf(Vest.enforce.greaterThanOrEquals(0), Vest.enforce.lessThanOrEquals(9));
    });
    */


    //-------------------
    // disabled versus standard amount check
    //-----------------

    Vest.test('depChildrenDis', 'ERROR_MORE_DIS_THAN_NORMAL', () => {
        return ( (parseInt(data.depChildren) < parseInt(data.depChildrenDis))?false:true);
    });

    Vest.test('depOthersDis', 'ERROR_MORE_DIS_THAN_NORMAL', () => {
        return ( (parseInt(data.depOthers) < parseInt(data.depOthersDis))?false:true);
    });

    Vest.test('dep65TransitionDis', 'ERROR_MORE_DIS_THAN_NORMAL', () => {
        return ( (parseInt(data.dep65Transition) < parseInt(data.dep65TransitionDis))?false:true);
    });

    /*
    Vest.test('dep65DependentDis', 'ERROR_MORE_DIS_THAN_NORMAL', () => {
        return ( (parseInt(data.dep65Dependent) < parseInt(data.dep65DependentDis))?false:true);
    });
    */
});